{
  "name": "app-ildato-articolidpi",
  "version": "0.1.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "build-themes": "devextreme build",
    "postinstall": "npm run build-themes"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.18",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.18",
    "@angular/compiler": "^20.3.18",
    "@angular/core": "^20.3.18",
    "@angular/forms": "^20.3.18",
    "@angular/localize": "^20.3.18",
    "@angular/platform-browser": "^20.3.18",
    "@angular/platform-browser-dynamic": "^20.3.18",
    "@angular/router": "^20.3.18",
    "@azure/msal-angular": "^5.1.4",
    "@azure/msal-browser": "^5.6.3",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.2.0",
    "@fortawesome/free-solid-svg-icons": "^7.2.0",
    "bootstrap": "^5.3.8",
    "devextreme": "25.2.5",
    "devextreme-angular": "25.2.5",
    "dompurify": "^3.3.3",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "font-awesome": "^4.7.0",
    "http": "0.0.1-security",
    "jquery": "^3.7.1",
    "js-sha512": "^0.9.0",
    "jsignature": "^2.1.3",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.7",
    "moment": "^2.30.1",
    "ngx-countdown": "^21.0.0",
    "ngx-extended-pdf-viewer": "^27.0.0",
    "rxjs": "^7.4.0",
    "rxjs-observable": "0.0.7",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.22",
    "@angular-eslint/template-parser": "^20.7.0",
    "@angular/cli": "^20.3.22",
    "@angular/compiler-cli": "^20.3.18",
    "@types/file-saver": "^2.0.7",
    "@types/node": "^12.20.55",
    "angular-eslint": "^20.7.0",
    "devextreme-cli": "^1.6.6",
    "devextreme-themebuilder": "25.2.5",
    "eslint": "^9.39.1",
    "karma-chrome-launcher": "^3.2.0",
    "ts-node": "~8.3.0",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.58.0"
  }
}
